<template>
    <div class="edit-mode">
        <VJoyTextarea v-model="contentNote" class="joy-mb-4" />
        <VJoyWrapper v-bind="{align: 'center', justify: 'flex-end', noMargin: true}">
            <VJoyButton :label="$t('general.cancel')" size="small" variant="ghost" @click="emits('cancel')" />
            <VJoyButton :label="$t('general.update')" size="small" variant="main" @click="emits('edit', contentNote)" />
        </VJoyWrapper>
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {VJoyButton, VJoyWrapper, VJoyTextarea} from '@maltjoy/core-vue';

    const props = defineProps<{
        content: string;
    }>();

    const emits = defineEmits<{
        (e: 'edit', value: string): void;
        (e: 'cancel'): void;
    }>();

    const contentNote = ref(props.content);
</script>
